<template>
    <section >
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                              <h4>Trip Location</h4>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.segregationPlant)">
                                        <label>Segregation Plant</label>
                                        <select v-model="trip.segregationPlant" name="segregationPlant" required class="form-control">
                                            <option disabled>Select segregation Plant</option>
                                            <option v-for="(item,index) in segregation_Plant" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="segregationPlant" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Segregation Plant is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.dumpYard)">
                                        <label>Dump Yard</label>
                                        <select v-model="trip.dumpYard" required name="dumpYard" class="form-control">
                                            <option disabled>Select Dump Yard</option>
                                            <option v-for="(item,index) in dump_Yard" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="dumpYard" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Dump Yard is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>                                
                            </div>
                            <div class="col-sm-12">
                              <h4>vehicle & Driver</h4>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicle)">
                                        <label>Vechile</label>
                                        <select required v-model="trip.vehicle" name="vehicle" class="form-control">
                                            <option disabled>Select Vechile</option>
                                            <option v-for="(item,index) in vehicle" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="vehicle" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Vehicle is a required field</div>
                                        </field-messages>                                        
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driver)">
                                        <label>Driver</label>
                                        <select required v-model="trip.driver" name="driver" class="form-control">
                                            <option disabled>Select Driver</option>
                                            <option v-for="(item,index) in driver" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="driver" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Driver is a required field</div>
                                        </field-messages>                                        
                                    </validate>
                                </div>
                            </div>
                           <div class="col-sm-12">
                              <h4>Schedule</h4>
                              <div class="col-sm-4">
                                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.startTime)">
                                    <label>Start Time</label><br>
                                      <vue-timepicker  id="startTime" required v-model="trip.startTime" lang="en" name="startTime" input-class="form-control" width="100%" use-utc="true"></vue-timepicker>
                                      <field-messages name="startTime" show="$touched || $submitted" class="form-control-feedback">
                                          <div slot="required">Start Time is a required field</div>
                                      </field-messages>
                                  </validate>
                              </div>
                              <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endTime)">
                                  <label>End Time</label><br>
                                  <vue-timepicker id="endTime" required v-model="trip.endTime" lang="en" name="endTime" input-class="form-control" width="100%" use-utc="true"></vue-timepicker>
                                  <field-messages name="endTime" show="$touched || $submitted" class="form-control-feedback">
                                      <div slot="required">End Time is a required field</div>
                                  </field-messages>
                                </validate>
                              </div>
                            </div>
                            <div class="col-sm-12">
                               <div class="col-sm-4">
                                          <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.startDate)">
                                             <label>Start Date</label>
                                              <date-picker  id="startDate" required v-model="trip.startDate" lang="en" name="startDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                                              <field-messages name="startDate" show="$touched || $submitted" class="form-control-feedback">
                                                  <div slot="required">Start Date is a required field</div>
                                                  <div slot="pattern">Schedule Date is invalid</div>
                                              </field-messages>
                                      </validate>
                                </div>
                                <div class="col-sm-4">
                                          <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endDate)">
                                            <label>End Date</label>
                                              <date-picker  id="endDate" required v-model="trip.endDate" lang="en" name="endDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                                              <field-messages name="endDate" show="$touched || $submitted" class="form-control-feedback">
                                                  <div slot="required">End Date is a required field</div>
                                                  <div slot="pattern">Schedule Date is invalid</div>
                                              </field-messages>
                                      </validate>
                                </div>
                            </div>
                           
                        </vue-form> 
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'primarytrip' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="createTrip" :disabled="!(formstate.$valid)">Create Trip</button>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    </section>
  </template>

    
    
<script>

import {
    formService,
    eventBus,
    transportService
} from '../../../services'
import {
    EVENTS
} from '../../../config'
import {
    USER_ROLES
} from '../../../config';
import {
    mapState
} from 'vuex';

export default {
    name: 'createSegregationTrip',
    data() {
        return {
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            trip : {},
            formstate: {},
            segregation_Plant: {},
            dump_Yard: {},
            driver:{},
            vehicle:{}
        }
    },

    methods: {
        fieldClassName: formService.fieldClassName,
    //     getTransport() {

    //         const params = {
    //             // $embed: ['user']
    //         }
    //             return this.$transportDataRepository.find(this.$route.params._id, params)
    //             .then((response) => {
  
    //                 this.transport = response.data;
    //                 this.oldTransport = _.cloneDeep(this.transport)
    //                 this.$store.dispatch('setBreadcrumbTitle', this.transport.transportName)
    //             })
    //             .catch((error) => {
    //                 console.error('TransportDetails.TransportUpdate-error:', error)
    //                 this.$snotify.error(error.message, 'Error!')
    //             })
    //     },

    //     createTransport() {
    //         this.loading = true;
    //         return transportService.addTransportPoint(this.transport)
    //             .then((response) => {
    //                 this.loading = false
    //                 this.flash = false
    //                 this.$snotify.success(`The ${this.transport.transportName} has been added successfully.`)
    //                 this.$router.push('/transport')
    //             })
    //             .catch(error => {
    //                 this.loading = false
    //                 this.loading = false
    //                 if(error.data.statusCode === 409){
    //                     this.$snotify.error(error.data.message, 'Error!')
    //                 }else{
    //                 this.$snotify.error("Transport Point Create Failed", 'Error!')
    //                 }
    //             });
    //     },

    //     clearChanges() {
    //         this.transport = _.cloneDeep(this.oldTransport)
    //         this.formstate._reset()
    //     },
    //     updateTransport() {
    //         this.loading = true
    //         this.transport.transportId = this.$route.params._id

    //         return transportService.updateTransportPoint(this.transport, this.oldTransport)
    //             .then((response) => {

    //                 this.loading = false
    //                 this.flash = false
    //                 this.formstate._reset()
    //                 this.oldTransport = _.cloneDeep(this.transport)
    //                 this.$snotify.success(`The ${this.transport.transportName} has been Updated successfully.`)
    //                 this.$router.push('/transport');
    //             })
    //             .catch(error => {
    //                 this.loading = false 
    //                 if(error.data.statusCode === 409){
    //                     this.$snotify.error(error.data.message, 'Error!')
    //                 }else{
    //                 this.$snotify.error("Transport Point Update Failed", 'Error!')
    //                 }
    //             })
    //     },
        
    // },
    // created() {
    //     const promises = [];
    //     this.loading = true;


    //     // promises.push(this.getTransport());
    //     if (this.$route.params && this.$route.params._id) {
    //         promises.push(this.getTransport());
    //     }
    //     Promise.all(promises)
    //         .then(() => {
    //             this.loading = false;
    //             this.ready = true;
    //         })
    //         .catch(() => {
    //             this.loading = false;
    //             this.$snotify.error('Create transport failed', 'Error!')
    //         });
    // },
    // beforeDestroy() {},


    // fieldClassName: function (field) {
    //     if (!field) {
    //         return '';
    //     }
    //     if ((field.$touched || field.$submitted) && field.$valid) {
    //         return 'has-success';
    //     }
    //     if ((field.$touched || field.$submitted) && field.$invalid) {
    //         return 'has-danger';
    //     }
    // },

    // computed: {
    //     ...mapState({
    //         user: state => state.auth.user,
    //     })
  }
}
</script>
    
    
<style>
 h4{
        font-weight: bold;
     }
.required-field>label::after {
    content: '*';
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #0F6940;
    color: white
}
.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
</style>



// WEBPACK FOOTER //
// createSegregationTrip.vue?1c08387c